import { t as Swiper } from "./swiper.esm-Dvfjl6Fb.js";
import { t as Mousewheel } from "./mousewheel-C-gtMpkm.js";
import { t as Navigation } from "./navigation-BSfLh-wX.js";
//#region src/scripts/extenders/design-yourself-swiper.js
var SwiperElement = class extends HTMLElement {
	constructor() {
		super();
		new Swiper(this.querySelector(".swiper"), {
			modules: [Mousewheel, Navigation],
			slidesPerView: "auto",
			freemode: true,
			spaceBetween: 12,
			mousewheel: { forceToAxis: true },
			navigation: {
				enabled: true,
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-previous"
			}
		});
	}
};
if (customElements.get("design-swiper-holder") === void 0) customElements.define("design-swiper-holder", SwiperElement);
//#endregion
